import { userAPI } from '../services/api';

const REVERSE_URL = 'https://api.bigdatacloud.net/data/reverse-geocode-client';

export const fetchLocation = () => new Promise((resolve) => {
  if (!navigator.geolocation) return resolve(null);
  navigator.geolocation.getCurrentPosition(
    async (pos) => {
      try {
        const res = await fetch(`${REVERSE_URL}?latitude=${pos.coords.latitude}&longitude=${pos.coords.longitude}&localityLanguage=en`);
        const d = await res.json();
        resolve({
          city: d.city || '',
          state: d.principalSubdivision || '',
          nationality: d.countryName || ''
        });
      } catch (e) {
        resolve(null);
      }
    },
    () => resolve(null),
    { timeout: 6000, maximumAge: 300000 }
  );
});

let captureInFlight = null;

export const maybeCaptureLocation = async (user) => {
  if (!user || user.role !== 'customer') return null;
  if (user.address?.city || user.address?.state) return null;
  if (captureInFlight) return captureInFlight;
  captureInFlight = (async () => {
    try {
      const loc = await fetchLocation();
      if (!loc || (!loc.city && !loc.state)) return null;
      const payload = {
        address: { ...(user.address || {}), city: loc.city, state: loc.state },
        nationality: user.nationality || loc.nationality || undefined
      };
      const res = await userAPI.updateProfile(payload);
      return res.data?.data?.user || null;
    } catch (e) {
      return null;
    } finally {
      captureInFlight = null;
    }
  })();
  return captureInFlight;
};
